<template>
    <div class="confirm-email-container">
        <div class="confirm-email-message">
           Thanks , you will be notified soon about Account activation. 
            <br>
            <button @click="logOut" class="refresh-btn">
                Ok
            </button>
        </div>
    </div>
</template>

<script>
import { supabase } from '../supabase';
export default {
    methods: {
        logOut() {
            supabase.auth.signOut()
        }
    },
}
</script>

<style scoped>
.confirm-email-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: #1976d2;
}

.confirm-email-message {
    color: #fff;
    font-size: 1.2rem;
    text-align: center;
    padding: 2rem 3rem;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.15);
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

.refresh-btn {
    margin-top: 1.5rem;
    padding: 0.6rem 1.5rem;
    background: #fff;
    color: #1976d2;
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    cursor: pointer;
    transition: background 0.2s;
}
.refresh-btn:hover {
    background: #e3eafc;
}
</style>